/**
 * hotelsStyles — CSS for hotel components inside the shadow DOM.
 *
 * Reuses the SAME CSS class names as ecommerceStyles.js
 * (.ttp-product-card, .ttp-product-picker, etc.) so RoomCard
 * renders identically to ItemCard. Only adds hotel-specific
 * overrides (per-night label, booking summary).
 *
 * Layout overrides for #voiceActiveState match ecommerceStyles.js
 * so the hotels area behaves the same way the ecommerce area does.
 */
import { generateEcommerceCSS } from '../ecommerce/ecommerceStyles.js';

export function generateHotelsCSS() {
  return generateEcommerceCSS() + `

/* ═══════════════════════════════════════
   HOTELS-SPECIFIC OVERRIDES
   ═══════════════════════════════════════ */

/* Hotels area mirrors ecommerce area */
.ttp-hotels-area {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
  flex: 1 1 0 !important;
  min-height: 0 !important;
  position: relative !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

/* Scroll snap for horizontal room cards */
.ttp-hotels-area .ttp-products-horizontal {
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
}
.ttp-hotels-area .ttp-product-card {
  scroll-snap-align: start;
}

/* Room-specific layout classes */
#voiceActiveState.ttp-rooms-visible .desktop-voice-section {
  display: none !important;
}
#voiceActiveState.ttp-rooms-visible .compact-voice-section {
  display: flex !important;
}
#voiceActiveState.ttp-rooms-visible .desktop-conversation-panel {
  flex: 0 0 auto !important;
}
#voiceActiveState.ttp-rooms-visible .conversation-history {
  display: none !important;
}
#voiceActiveState.ttp-rooms-visible .live-transcript-collapsed {
  flex: 0 0 auto !important;
}

/* Amenity tags overlaid on room image */
.ttp-room-amenities {
  position: absolute;
  bottom: 6px;
  left: 6px;
  right: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.ttp-amenity-tag {
  font-size: 9px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(0,0,0,0.55);
  color: rgba(255,255,255,0.85);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.ttp-amenity-more {
  color: rgba(255,255,255,0.5);
}

/* Per-night price styling */
.ttp-room-per-night {
  font-size: 10px;
  color: rgba(255,255,255,0.35);
  font-weight: 400;
}

/* Booking summary bar */
.ttp-booking-summary-inline {
  margin: 0 !important;
  padding: 0 !important;
  padding-top: 8px !important;
  flex-shrink: 0 !important;
  background: transparent !important;
  border: none !important;
  border-top: 1px solid rgba(255,255,255,0.06) !important;
  border-radius: 0 !important;
  width: 100% !important;
  flex-basis: 100% !important;
}

.ttp-booking-summary {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
  flex-shrink: 0 !important;
}

.ttp-booking-summary.ttp-booking-empty {
  display: none !important;
}

.ttp-booking-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255,255,255,0.6);
}

.ttp-booking-total {
  font-size: 13px;
  font-weight: 700;
  color: #e8e4f0;
}

  `;
}
